export enum VivaOnboardingStatus {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
}
